import React from 'react';
import { Typography, Card, Row, Col, Button, Space, Divider } from 'antd';
import { 
  FileOutlined, 
  ShoppingOutlined, 
  DollarOutlined, 
  ClockCircleOutlined,
  UserOutlined,
  HeartOutlined,
  TrophyOutlined,
  TeamOutlined,
  BookOutlined,
  BarChartOutlined,
  MedicineBoxOutlined,
  AimOutlined,
  ReloadOutlined,
  BulbOutlined,
  ExclamationCircleOutlined,
  EnvironmentOutlined,
  PlayCircleOutlined,
  HomeOutlined,
  ThunderboltOutlined,
  CheckCircleOutlined,
  PhoneOutlined,
  MailOutlined,
  GlobalOutlined,
  CopyrightOutlined
} from '@ant-design/icons';

const { Title, Paragraph, Text, Link } = Typography;

const ProductShowcase = () => {
  const modules = [
    {
      id: 'files',
      title: '文件管理',
      desc: '文档资料的分类存储、检索和管理',
      icon: <FileOutlined />,
      color: '#FF6B6B'
    },
    {
      id: 'items',
      title: '物品管理',
      desc: '家庭物品清单管理、位置追踪',
      icon: <ShoppingOutlined />,
      color: '#4ECDC4'
    },
    {
      id: 'finance',
      title: '资金管理',
      desc: '收支记录、财务统计分析',
      icon: <DollarOutlined />,
      color: '#F7DC6F'
    },
    {
      id: 'time',
      title: '时间管理',
      desc: '日程安排、任务提醒、时间统计',
      icon: <ClockCircleOutlined />,
      color: '#85C1E9'
    },
    {
      id: 'customers',
      title: '客户管理',
      desc: 'CRM客户关系管理、跟进记录',
      icon: <UserOutlined />,
      color: '#45B7D1'
    },
    {
      id: 'emotions',
      title: '情绪管理',
      desc: '情绪记录、分析、趋势图表',
      icon: <HeartOutlined />,
      color: '#FFA07A'
    },
    {
      id: 'body',
      title: '身材管理',
      desc: '体重记录、健康数据追踪',
      icon: <TrophyOutlined />,
      color: '#98D8C8'
    },
    {
      id: 'contacts',
      title: '人际管理',
      desc: '通讯录、关系维护、生日提醒',
      icon: <TeamOutlined />,
      color: '#BB8FCE'
    },
    {
      id: 'study',
      title: '学习管理',
      desc: '学习计划、笔记管理、进度追踪',
      icon: <BookOutlined />,
      color: '#F8C471'
    },
    {
      id: 'projects',
      title: '项目管理',
      desc: '任务协作、进度跟踪、团队管理',
      icon: <BarChartOutlined />,
      color: '#82E0AA'
    },
    {
      id: 'health',
      title: '健康管理',
      desc: '用药提醒、健康档案、体检记录',
      icon: <MedicineBoxOutlined />,
      color: '#F1948A'
    },
    {
      id: 'goals',
      title: '目标管理',
      desc: '目标设定、达成追踪、复盘总结',
      icon: <AimOutlined />,
      color: '#D7BDE2'
    },
    {
      id: 'habits',
      title: '习惯管理',
      desc: '习惯养成、打卡记录、统计分析',
      icon: <ReloadOutlined />,
      color: '#F9E79F'
    },
    {
      id: 'creative',
      title: '创意管理',
      desc: '灵感记录、创意整理、项目孵化',
      icon: <BulbOutlined />,
      color: '#FAD7A0'
    },
    {
      id: 'risk',
      title: '风险管理',
      desc: '风险评估、预防措施管理',
      icon: <ExclamationCircleOutlined />,
      color: '#E8DAEF'
    },
    {
      id: 'environment',
      title: '环境管理',
      desc: '常用地点收藏、地址管理',
      icon: <EnvironmentOutlined />,
      color: '#A9DFBF'
    },
    {
      id: 'entertainment',
      title: '娱乐管理',
      desc: '娱乐活动记录、推荐管理',
      icon: <PlayCircleOutlined />,
      color: '#F5CBA7'
    },
    {
      id: 'family',
      title: '家庭管理',
      desc: '家庭信息管理、成员档案',
      icon: <HomeOutlined />,
      color: '#D5A6BD'
    },
    {
      id: 'energy',
      title: '能量管理',
      desc: '精力管理、效率优化',
      icon: <ThunderboltOutlined />,
      color: '#AED6F1'
    },
    {
      id: 'decisions',
      title: '决策管理',
      desc: '决策记录、结果追踪、经验总结',
      icon: <CheckCircleOutlined />,
      color: '#ABEBC6'
    }
  ];

  return (
    <div style={{ maxWidth: 1200, margin: '20px auto', padding: '0 16px' }}>
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <Title level={2}>管理师软件 - 产品展示</Title>
        <Paragraph style={{ fontSize: '16px', color: '#666' }}>
          全方位个人和团队管理系统，涵盖生活和工作的20个核心模块
        </Paragraph>
      </div>

      <Row gutter={[16, 16]}>
        {modules.map((module) => (
          <Col xs={24} sm={12} md={8} lg={6} key={module.id}>
            <Card
              hoverable
              style={{ 
                height: '140px',
                border: `2px solid ${module.color}`,
                borderRadius: '12px'
              }}
              bodyStyle={{ 
                padding: '16px',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <div style={{ 
                fontSize: '24px', 
                color: module.color, 
                marginBottom: '8px' 
              }}>
                {module.icon}
              </div>
              <Title level={5} style={{ 
                margin: '0 0 4px 0', 
                textAlign: 'center',
                color: module.color 
              }}>
                {module.title}
              </Title>
              <Text style={{ 
                fontSize: '12px', 
                color: '#666',
                textAlign: 'center',
                lineHeight: '1.4'
              }}>
                {module.desc}
              </Text>
            </Card>
          </Col>
        ))}
      </Row>

      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        <Card style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
          <Title level={3} style={{ color: 'white', marginBottom: '16px' }}>
            立即体验管理师软件
          </Title>
          <Paragraph style={{ color: 'white', fontSize: '16px', marginBottom: '20px' }}>
            注册即享基础功能，升级VIP解锁全部20个模块
          </Paragraph>
          <Space size="large">
            <Button 
              type="primary" 
              size="large"
              style={{ 
                background: 'white', 
                color: '#667eea',
                border: 'none',
                fontWeight: 'bold'
              }}
              onClick={() => window.location.href = '/'}
            >
              立即使用
            </Button>
            <Button 
              size="large"
              style={{ 
                background: 'transparent', 
                color: 'white',
                border: '1px solid white'
              }}
              onClick={() => window.location.href = '/about'}
            >
              了解更多
            </Button>
          </Space>
        </Card>
      </div>
    </div>
  );
};

export default ProductShowcase;
